import { render, staticRenderFns } from "./MenuSection.vue?vue&type=template&id=0bf21faa&"
import script from "./MenuSection.vue?vue&type=script&lang=js&"
export * from "./MenuSection.vue?vue&type=script&lang=js&"
import style0 from "./MenuSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MenuSection.vue"
export default component.exports